import axios from 'axios';
import { City } from '@/domain/city.entity';
import { Pref } from '@/domain/pref.entity';
import { Town } from '@/domain/town.entity';

const PREFMAP = [
  null,
  '北海道',
  '青森県',
  '岩手県',
  '宮城県',
  '秋田県',
  '山形県',
  '福島県',
  '茨城県',
  '栃木県',
  '群馬県',
  '埼玉県',
  '千葉県',
  '東京都',
  '神奈川県',
  '新潟県',
  '富山県',
  '石川県',
  '福井県',
  '山梨県',
  '長野県',
  '岐阜県',
  '静岡県',
  '愛知県',
  '三重県',
  '滋賀県',
  '京都府',
  '大阪府',
  '兵庫県',
  '奈良県',
  '和歌山県',
  '鳥取県',
  '島根県',
  '岡山県',
  '広島県',
  '山口県',
  '徳島県',
  '香川県',
  '愛媛県',
  '高知県',
  '福岡県',
  '佐賀県',
  '長崎県',
  '熊本県',
  '大分県',
  '宮崎県',
  '鹿児島県',
  '沖縄県',
];

export interface Zip2AddressForm {
  zip: string | string[];
}

export interface PrefGetForm {
  zip: string | string[];
}

export interface GetPrefListForMypageEstate {
  fcShopId: number;
}
export interface GetCityByFcShopForm {
  fcShopId: number,
  prefId: number
}
// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface GetPrefForm {
  prefId?: number | number[]
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface GetCityForm {
}

export interface IGetTownListForm {
  prefId: number;
  cityId: number;
}

type PrefectureListBody = {
  id: number;
  name: string;
  cities: {
    id: number;
    name: string;
  }[]
}[]

export type ListPrefecturesResult = Array<Pref & { cities: Array<City> }>
export default {
  async listPrefectures(query: GetPrefForm): Promise<ListPrefecturesResult> {
    const params: {prefId?: number | number[]} = {};
    if (params.prefId) params.prefId = query.prefId;

    const res = await axios.get<PrefectureListBody>('/location/prefecture', { params });
    const { data } = res;
    return data.map((item) => ({
      id: Number(item.id),
      name: item.name,
      cities: item.cities.map((city) => ({
        id: Number(city.id),
        name: city.name,
        prefId: item.id,
      })),
    }));
  },
  async getCities(query: GetCityForm): Promise<City[]> {
    const res = await axios.get('/cities/', { params: query });
    const data = res.data as {
      id: string;
      name: string;
      prefId: string;
    }[];
    return data.map((item) => ({
      id: Number(item.id),
      name: item.name,
      prefId: Number(item.prefId),
    }));
  },
  async getTowns(query: IGetTownListForm): Promise<Town[]> {
    const towns = await axios.get<Town[]>('/town/list', { params: query });
    return towns.data;
  },
  async zipToAddress(form: Zip2AddressForm) {
    const zip = (Array.isArray(form.zip) ? form.zip.join('') : form.zip).replace('-', '');
    const url = `https://yubinbango.github.io/yubinbango-data/data/${encodeURIComponent(zip.substring(0, 3))}.js?callback=$yubin`;
    let res = await fetch(url).then((fetchRes) => fetchRes.text());
    res = res.replace('$yubin(', '').replace(');', '');
    const jsonResponse = JSON.parse(res);
    let addresses = jsonResponse[zip];

    const opera = `${Number.parseInt(zip, 10) + 0xff000000}`;
    if (!addresses && jsonResponse[opera]) addresses = jsonResponse[opera];
    const [prefId, cityName, address] = addresses;
    const prefName = PREFMAP[prefId];
    return {
      prefId, prefName, cityName, address,
    };
  },

  async getPrefByFcShop(form: GetPrefListForMypageEstate): Promise<Pref[]> {
    const res = await axios.get('/doNetwork/getPrefListForMypageEstate', { params: form });
    const data = res.data as { id: string, name: string }[];
    return data.map((item) => ({
      id: Number(item.id),
      name: item.name,
      cities: [],
    }));
  },
  async getCityByFcShop(form: GetCityByFcShopForm) {
    const response = await axios.get('/doNetwork/getCityListForMypageEstate', {
      params: {
        fcShopId: form.fcShopId,
        prefId: String(form.prefId).padStart(2, '0'),
      },
    });
    return response.data as City[];
  },

  async getTownInfoListByZipCode(form: { zipCode: string }): Promise<(Town & { city: City, pref: Pref })[]> {
    const response = await axios.get('/location/town-info-list', { params: form });
    const data = response.data as {
      id: number,
      prefId: number,
      cityId: number,
      name: string,
      zipCode: string,
      pref: {
        id: number,
        name: string,
        kanaName: string,
      },
      city: {
        id: number,
        name: string,
        prefId: number,
        kanaName: string,
      }
    }[];
    return data;
  },
};
